import SessionStorageService from '../SessionStorageService'
import StorageKeysConfig from '../StorageKeysConfig'

const moduleTmp = StorageKeysConfig.VOCUST_APP_BASE_ID

export const getAppBaseConfig = () => {
  return (
    SessionStorageService.getItem(moduleTmp.Key) ||
    new moduleTmp.EntityClass({
      appId: 'Basic Y2VtX212cDpjZW1fbXZwX3NlY3JldA==',
      appName: 'hotelcem',
      token: undefined,
      ssoToken: undefined,
      userInfo: undefined,
      loginSsoToken: undefined,
      menus: [],
    })
  )
}

const setAppBaseConfig = data => {
  SessionStorageService.setItem(moduleTmp.Key, new moduleTmp.EntityClass(data))
}

export const checkAppBaseConfigExists = () => {
  return !!getAppBaseConfig()?.menus?.length
}

export const updateAppBaseConfig = data => {
  // 检查当前APPID是否与缓存中的APPID一致
  const entity = getAppBaseConfig()
  if (entity && entity.appId === data.appId) {
    return
  }
  setAppBaseConfig({
    ...entity,
    ...data,
    menus: [],
  })
}

export const setUserInfo = userInfo => {
  setAppBaseConfig({
    ...getAppBaseConfig(),
    userInfo,
  })
}

export const getUserInfo = () => {
  return getAppBaseConfig()?.userInfo
}

export const clearAppBaseConfig = () => {
  SessionStorageService?.removeItem(moduleTmp.Key)
}

export const resetAppMenus = (menus = []) => {
  setAppBaseConfig({
    ...getAppBaseConfig(),
    menus,
  })
}

export const setToken = token => {
  setAppBaseConfig({
    ...getAppBaseConfig(),
    token,
  })
}

export const setSSOToken = ssoToken => {
  setAppBaseConfig({
    ...getAppBaseConfig(),
    ssoToken,
  })
}

export const setLoginSSOToken = loginSsoToken => {
  setAppBaseConfig({
    ...getAppBaseConfig(),
    loginSsoToken,
  })
}
